import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import ReactPaginate from 'react-paginate';

import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

type Props = PropsWithClassName<{
  currentPage: number;
  loadMore?: (pageNumber?: number) => void;
  className?: string;
  onPageChange: (selectedItem: { selected: number }) => void;
  pageCount: number;
}>;

export const PaginatorAsync = ({
  currentPage,
  onPageChange,
  pageCount,
  className,
}: Props) => {
  return (
    <ReactPaginate
      activeClassName="active"
      breakLabel=""
      className={cn('paginator-gdt w-full items-center ', className)}
      containerClassName="w-full"
      forcePage={currentPage}
      marginPagesDisplayed={0}
      nextClassName="page-item"
      nextLabel={
        <div className="flex items-center">
          <span className="pr-2">Siguiente</span>
          <GoArrowRight size={15} />
        </div>
      }
      pageClassName="page-item"
      pageCount={pageCount}
      previousLabel={
        <div className="flex items-center">
          <GoArrowLeft size={15} />
          <span className="pl-2">Anterior</span>
        </div>
      }
      onPageChange={onPageChange}
    />
  );
};
